var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c("invitation",{tag:"component"}):(_vm.ticketEvent)?_c("ticketInvitation",{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }